import DismissibleCardRoot, { Props } from './DismissibleCard'

export default function DismissibleCard(props: Props) {
  return <DismissibleCardRoot {...props} />
}
